(() => {
  const ensureBhdProductMediaOverlayStyles = () => {
    if (document.getElementById('BHDProductMediaOverlayStyles')) return;

    const style = document.createElement('style');
    style.id = 'BHDProductMediaOverlayStyles';
    style.textContent = `
      @media (max-width: 749px) {
        body.bhd-product-media-open #BHDGlobalBundle,
        body.bhd-product-media-open #barrio-sticky-header {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
        ensureBhdProductMediaOverlayStyles();
      }

      hide() {
        super.hide();
        document.body.classList.remove('bhd-product-media-open');
        window.pauseAllMedia();
      }

      show(opener) {
        ensureBhdProductMediaOverlayStyles();
        document.body.classList.add('bhd-product-media-open');
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('is-active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('is-active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }
})();
